import axios from "axios";
import {
  fetchCameraReportData,
  createandgetTagEndPoint,
  createNewandGetTagEndPoint,
  fetchCameraReportDataAggregated,
  fetchCameraReportDataForEEAppAggregated,
  getTagHierarchyEndPoint,
  uploadMediaEndPoint,
  downloadMediaEndPoint,
  createTagHierarchyEndPoint,
  getStatisticsAggegateCountsEndPoint,
  retrieveUserSitesEndPoint,
  createNewSiteLabelEndPoint
} from "../configuration";
import { DEVICE_STORAGE_NAMES } from "../global/constants/devices";
import {
  convertNumToTime,
  calculateStartTime,
  startsTodayDate,
} from "../global/utility/Utils";
import { getRandomUUID } from "../../src/Token";
import axiosInstance from "../global/axiosInterceptor";
import { handleApiError } from "../global/utility/Utils";

export const trendsPageTypes = {
  PEOPLE_IN_VENUE: "peopleInVenue",
  LINE_LENGTH: "peopleCounts&DwellTimes",
};

export const tagTypes = {
  CONCESSION: "Concessions",
  BATHROOM: "Bathrooms",
  ENTRY: "Entry",
  EXIT: "Exit",
  DISPLAY_AREAS: "ts.tag.displayareas",
};

export const reportType = {
  WAIT_TIME: "waitTime",
  PEOPLE_COUNT: "peopleCount",
};

export const storedTagIds = () => {
  return JSON.parse(sessionStorage.getItem(`${DEVICE_STORAGE_NAMES[6]}`));
};

export const displayTypes = {
  DASHBOARD: "dashboard",
  TRENDS: "trends",
  TRENDS_DETAILS: "trendsDetails",
};

export const aggregateTypes = {
  SUM: "sum",
  AVERAGE: "averageinwindow",
  MAX_IN_INTERVAL: "maxininterval",
  SUM_IN_INTERVAL: "sumininterval",
  SUM_WINDOW_IN_INTERVAL: "sumwindowininterval",
  LATEST_IN_INTERVAL: "latestininterval"
};

export const fetchPeriodicReports = async (payload, activeSession) => {
  try {
    let data = {};
    var range = calculateStartTime(undefined, payload.deductTime);
    const entryTag = getTagId(tagTypes.ENTRY);
    const exitTag = getTagId(tagTypes.EXIT);
    const entryCount = await getAggregateFor(
      range,
      entryTag,
      aggregateTypes.SUM,
      "fields.PeopleCount.count",
      activeSession
    );
    data.entryCount = entryCount?.peopleCount_overtime[0]?.count
      ? entryCount.peopleCount_overtime[0].count
      : 0;
    const exitCount = await getAggregateFor(
      range,
      exitTag,
      aggregateTypes.SUM,
      "fields.PeopleCount.count",
      activeSession
    );
    data.exitCount = exitCount?.peopleCount_overtime[0]?.count
      ? exitCount.peopleCount_overtime[0].count
      : 0;
    data.peopleCount = data.entryCount - data.exitCount;
    data.areas = [];
    for (const tag of payload.areaTagData) {
      const id = getTagId(tag.name);
      const areaCount = await getAggregateFor(
        range,
        id,
        aggregateTypes.SUM,
        "fields.PeopleCount.count",
        activeSession
      );
      const areaWaitTime = await getAggregateFor(
        range,
        id,
        aggregateTypes.AVERAGE,
        "fields.AverageWaitTime.average",
        "1d",
        activeSession
      );
      let subdata = {};
      subdata.areaName = tag.name;
      subdata.count = areaCount?.peopleCount_overtime[0]?.count
        ? entryCount.peopleCount_overtime[0].count
        : 0;
      subdata.waitTime = areaWaitTime?.peopleCount_overtime
        ? areaWaitTime?.peopleCount_overtime[
            areaWaitTime?.peopleCount_overtime.length - 1
          ]?.value?.avg?.value
        : 0;
      data.areas.push(subdata);
    }
    range = `createdon > '${new Date(
      Date.now() - payload.trafficFlowInterval * 1000
    ).toISOString()}'`;
    const netFlowIn = await getAggregateFor(
      range,
      entryTag,
      aggregateTypes.SUM,
      "fields.PeopleCount.count",
      activeSession
    );
    const netFlowOut = await getAggregateFor(
      range,
      exitTag,
      aggregateTypes.SUM,
      "fields.PeopleCount.count",
      activeSession
    );
    data.netFlow =
      (netFlowIn?.peopleCount_overtime[0]?.count
        ? netFlowIn.peopleCount_overtime[0].count
        : 0) -
      (netFlowOut?.peopleCount_overtime[0]?.count
        ? netFlowOut.peopleCount_overtime[0].count
        : 0);
    return data;
  } catch (e) {
    console.log(e);
    return;
  }
};

export const fetchGraphStartCount = async (payload, activeSession) => {
  try {
    const entryTag = getTagId(tagTypes.ENTRY);
    const exitTag = getTagId(tagTypes.EXIT);
    let entryCount = await getAggregateFor(
      payload.dateRange,
      entryTag,
      aggregateTypes.SUM,
      "fields.PeopleCount.count",
      activeSession
    );
    entryCount = entryCount?.peopleCount_overtime[0]?.count
      ? entryCount.peopleCount_overtime[0].count
      : 0;
    let exitCount = await getAggregateFor(
      payload.dateRange,
      exitTag,
      aggregateTypes.SUM,
      "fields.PeopleCount.count",
      activeSession
    );
    exitCount = exitCount?.peopleCount_overtime[0]?.count
      ? exitCount.peopleCount_overtime[0].count
      : 0;
    return entryCount - exitCount;
  } catch (e) {
    console.log(e);
    return;
  }
};

export const getHistoryCreatedOn = async (
  range,
  deviceId,
  field,
  activeSession
) => {
const parts = field.split('.');
const fieldSecondPart = parts[1];
const fieldFirstAndSecondPart = parts.slice(0, 2).join('.');
  try {
    const response = await axiosInstance.post(
      fetchCameraReportData(),
     {
       accountname: activeSession.accountId,
        resourceidentifier: {
        deviceid: deviceId
       },
       filter: {
         $selection: `(${range}) and ($/fields containskey '${fieldSecondPart}')`,
         $limitnumber: 1,
         $sort: [
           {
             "field": "createdon",
             "order": "desc"
           }
         ],
         $projection: [
           fieldFirstAndSecondPart
         ]
       }
    }
    );    
    return response.data;
  } catch (e) {
    console.log(e);
    return;
  }
};


export const getAggregateFor = async (
  range,
  tagType,
  kind,
  field,
  interval = "10s",
  activeSession,
  minDate,
  maxDate
) => {
  try {
    const response = await axiosInstance.post(
      fetchCameraReportDataAggregated(),
      {
        accountname: activeSession.accountId,
        referenceidentifier: {
          tagid: tagType,
        },
        filter: {
          $selection: range ? range : calculateStartTime(),
          $aggs: [
            {
              name: "peopleCount_overtime",
              kind: kind,
              field: field,
              datehistogram: {
                field: "createdon",
                fixedinterval: interval ? interval : "30m",
                extendedbounds:{
                  min: minDate,
                  max: maxDate
                 }
              },
            },
          ],
        },
      }
    );    
    return response.data;
  } catch (e) {
    console.log(e);
    return;
  }
};

export const getAggregateForEntryExitApp = async (
  range,
  tagType,
  kind,
  field,
  interval = "10s",
  activeSession,
  minDate,
  maxDate
) => {
  try {
    const response = await axiosInstance.post(
      fetchCameraReportDataForEEAppAggregated(),
      {
        accountname: activeSession.accountId,
        referenceidentifier: {
          tagid: tagType,
        },
        filters: [{
            $aggs: [
                {
                    field: field,
                    kind: "lastknownvalue",
                    name: "people_count_starting_balance",
                    lastknownvalue: {
                        to: minDate
                    }
                }
            ]
        },
          {
          $selection: range ? range : calculateStartTime(),
          $aggs: [
            {
              name: "peopleCount_overtime",
              kind: kind,
              field: field,
              datehistogram: {
                field: "createdon",
                fixedinterval: interval ? interval : "30m",
                extendedbounds:{
                  min: minDate,
                  max: maxDate
                 }
              },
            },
          ],
        },
      ]
      }
    );    

    let data = response.data["peopleCount_overtime"];
    if (data && data.length > 0 && data[0]?.value?.latest?.value === null) {
      const startingBalance = response.data["people_count_starting_balance"];
      if (startingBalance && startingBalance.length > 0) {
        data[0].value.latest.value = startingBalance[0].value;
      }
    }

    return {responseData : data, fullresponse: response.data};
  } catch (e) {
    console.log(e);
    return;
  }
};


export const getAggregateForPeopleCountEE = async (
  range,
  tagType,
  kind,
  field,
  interval = "10s",
  activeSession
) => {
  try {
    const response = await axiosInstance.post(
      fetchCameraReportDataAggregated(),
      {
        accountname: activeSession.accountId,
        referenceidentifier: {
          tagid: tagType,
        },
        filter: {
          $selection: range ? range : calculateStartTime(),
          $aggs: [
            {
              name: "peopleCount_overtimeIn",
              kind: "sumininterval",
              field: "fields.PeopleCountEE.in",
              datehistogram: {
                field: "createdon",
                fixedinterval: interval ? interval : "30m",
              },
            },
            {
              name: "peopleCount_overtimeOut",
              kind: "sumininterval",
              field: "fields.PeopleCountEE.out",
              datehistogram: {
                field: "createdon",
                fixedinterval: interval ? interval : "30m",
              },
            },
          ],
        },
      }
    );
    return response.data;
  } catch (e) {
    console.log(e);
    return;
  }
};

export const getAggregateForstatistics = async (
  range,
  tagType,
  activeSession,
  filteraggregate
) => {
  try {
    const response = await axiosInstance.post(
      getStatisticsAggegateCountsEndPoint(),
      {
        accountname: activeSession.accountId,
        referenceidentifier: {
          tagid: tagType,
        },
        filter: {
          $selection: range ? range : calculateStartTime(),
          $aggs: filteraggregate,
        },
      }
    );
    return response.data;
  } catch (e) {
    console.log(e);
    return;
  }
};

export const getTagId = (tagType) => {
  const tagData = JSON.parse(sessionStorage.getItem("TagIdsList"));
  const tagId = tagData?.filter((item) => {
    if (item.name === tagType) {
      return item.id;
    }
  });
  return tagId && tagId.length ? tagId[0]?.id : "";
};

export const fetchReportsData = async (tagData) => {
  try {
    const cameralist = JSON.parse(sessionStorage.getItem(`deviceList`)).filter(
      (item) => item.kind === "ts.device.onvif.fov"
    );
    const data = await Promise.all(
      cameralist.map((item) => fetchReportForCamera(item))
    );
    return await reportFetchAction(data, tagData);
  } catch (e) {
    console.log(e);
    return;
  }
};

export const fetchReportForCamera = async (
  cameraObject,
  dateRange = undefined,
  activeSession
) => {
  try {
    let resourceidentifier = {};
    resourceidentifier["deviceid"] = cameraObject.refid;

    const response = await axiosInstance.post(fetchCameraReportData(), {
      accountname: activeSession.sessionToken,
      resourceidentifier: resourceidentifier,
      filter: {
        $selection: dateRange
          ? dateRange
          : `createdon > '${new Date(
              Date.now() - 3600 * 1000 * 1
            ).toISOString()}'`,
      },
    });
    const res = response.data;
    return { [cameraObject.refid]: res };
  } catch (e) {
    console.log(e);
    return;
  }
};

export const checkIfTagExists = (kind, name, parentID) => {
  try {
    const tagData = JSON.parse(sessionStorage.getItem("TagIdsList"));
    let sameNameTags = tagData?.filter(
      (item) => item.name === name && item.kind === kind
    );

    if (sameNameTags?.length > 0) {
      if (parentID) {
        const sameParentIDTag = sameNameTags?.find((tag) =>
          tag?.tagids?.includes(parentID)
        );
        if (sameParentIDTag) {
          return sameParentIDTag.id;
        }
      }
      return sameNameTags[0]?.id;
    }
    return null;
  } catch (e) {
    console.log("Error fetching tag exists", e);
    return null;
  }
};

export const createTagIfNotExists = async (
  activeSession,
  kind,
  name,
  parentID,
  imageId
) => {
  try {
    const existingTagId = await checkIfTagExists(kind, name, parentID);
    console.log("Existing ID", existingTagId);
    if (existingTagId) {
      console.log(`Tag with name '${name}' and kind '${kind}' already exists`);
      return existingTagId;
    }
    const response = await axiosInstance.post(createNewandGetTagEndPoint(), {
      accountname: activeSession?.accountId,
      tags: [
        {
          kind: kind,
          name: name,
          tagids: parentID ? [parentID] : [],
          ...(imageId && { imageid: imageId }),
        },
      ],
    });
    const res = response.data;
    return res[0];
  } catch (error) {
    console.error("Error creating tags:", error);
    return null;
  }
};

export const createTagInEditMode = async (
  activeSession,
  kind,
  name,
  parentID,
  imageId,
  forcefully = false
) => {
  try {
    const existingTagId =
      !["floor", "area", "subarea"].some((kindType) =>
        kind.includes(kindType)
      ) && (await checkIfTagExists(kind, name, parentID));
    if (existingTagId && !forcefully) {
      console.log(`Tag with name '${name}' and kind '${kind}' already exists`);
      return existingTagId;
    }
    const response = await axiosInstance.post(createNewSiteLabelEndPoint(), {
      accountname: activeSession?.accountId,
      tags: [
        {
          kind: kind,
          name: name,
          tagids: parentID ? [parentID] : [],
          ...(imageId && { imageid: imageId }),
        },
      ],
    });
    return response.data;
  } catch (error) {
    console.error("Error creating tags:", error);
    return null;
  }
};

export const createFormTag = async (payload) => {
  try {
    const response = await axiosInstance.post(
      createTagHierarchyEndPoint(),
      payload
    );
    const res = response.data;
    return res;
  } catch (error) {
    console.error("Error creating tags:", error);
    const errorMessage = error?.response?.data?.error_description;
    handleApiError("warning", errorMessage ? errorMessage : "Failed to update Campus, please try again.");
    return [];
    return null;
  }
};

export const getTagHierarchy = async (
  options,
  resourceidentifier,
  activeSession
) => {
  try {
    const response = await axiosInstance.post(getTagHierarchyEndPoint(), {
      accountname: activeSession.accountId,
      options: options,
      resourceidentifier: resourceidentifier,
    });
    const res = response.data;
    return res;
  } catch (error) {
    console.log(error, "Error fetching tag hierarchy");
    return [];
  }
};

export const fetchTagData = async (activeSession) => {
  try {
    const response = await axiosInstance.post(createandgetTagEndPoint(), {
      accountname: activeSession?.accountId,
    });
    const res = response.data;
    sessionStorage.setItem(`${DEVICE_STORAGE_NAMES[6]}`, JSON.stringify(res));
    return res;
  } catch (e) {
    console.log(e);
    return { error: true };
  }
};

export const getUserSitesData = async (activeSession) => {
  try {
    const response = await axiosInstance.post(retrieveUserSitesEndPoint(), {
      accountname: activeSession.accountId,
      grant: {
        userid: activeSession.userId,
      },
    });
    const res = response.data;
    return res;
  } catch (e) {
    const errorMessage = e?.response?.data?.error_description;
    console.error("Error to retrieve sites endpoint:", e);
    handleApiError("warning", errorMessage ? errorMessage : "User sites query call failed!");
    return [];
  }
};

export const filterAndStoreData = (res, sitesList) => {
  let countries = [];
  let states = [];
  let cities = [];
  let campuses = [];
  let sites = [];
  let floors = [];
  let areas = [];
  let subareas = [];
  let others = [];

  res?.forEach((item) => {
    switch (item.kind.toLowerCase()) {
      case "ts.tag.country":
        countries.push(item);
        break;
      case "ts.tag.state":
        states.push(item);
        break;
      case "ts.tag.city":
        cities.push(item);
        break;
      case "ts.tag.campus":
        campuses.push(item);
        break;
      case "ts.tag.floor":
        floors.push(item);
        break;
      case "ts.tag.area":
        areas.push(item);
        break;
      case "ts.tag.subarea":
        subareas.push(item);
        break;
      case "ts.tag.site":
        sites.push(item);
        break;
      default:
        others.push(item);
        break;
    }
  });
  sites = sitesList?.length ? sitesList : sites;
  const list = {
    areas,
    campuses,
    cities,
    countries,
    floors,
    states,
    others,
    sites,
    subareas,
  };

  return list;
};

export const processNestedTags = (tags) => {
  const transformedJson = {
    countries: [],
    areas: [],
    campuses: [],
    cities: [],
    floors: [],
    states: [],
    others: [],
    sites: [],
    subareas: [],
  };
  const processTags = (tag, parentId = null) => {
    const entry = {
      id: tag.id,
      kind: tag.kind,
      // version: tag.version,
      // versionid: tag.versionid,
      // createdon: tag.createdon,
      // lastupdated: tag.lastupdated,
      name: tag.name,
      imageid: tag.imageid,
      imageurl: tag.imageurl,
      parkingcount : tag?.parkingcount,
      // foreignid: tag.foreignid,
      billingaccountid: tag?.billingaccountid,
      tagids: Array.isArray(tag.tagids)
        ? tag.tagids
        : parentId
        ? [parentId]
        : [],
    };
    switch (tag.kind) {
      case "ts.tag.country":
        transformedJson.countries.push(entry);
        break;
      case "ts.tag.state":
        transformedJson.states.push(entry);
        break;
      case "ts.tag.city":
        transformedJson.cities.push(entry);
        break;
      case "ts.tag.campus":
        entry.description = tag.description || "";
        transformedJson.campuses.push(entry);
        break;
      case "ts.tag.site":
        transformedJson.sites.push(entry);
        break;
      case "ts.tag.floor":
        transformedJson.floors.push(entry);
        break;
      case "ts.tag.area":
        transformedJson.areas.push(entry);
        break;
      case "ts.tag.subarea":
        transformedJson.subareas.push(entry);
        break;
      case "ts.tag.subArea":
        transformedJson.subareas.push(entry);
        break;
      default:
        transformedJson.others.push(entry);
    }
    if (tag?.nestedtags) {
      tag?.nestedtags?.forEach((nestedTag) => processTags(nestedTag, tag.id));
    }
  };

  tags?.forEach((tag) => processTags(tag));
  return transformedJson;
};

export const fetchAreaTags = async (tagData) => {
  try {
    const areaTags = tagData.filter((item) => {
      return item.kind === tagTypes.DISPLAY_AREAS;
    });
    return areaTags;
  } catch (e) {
    console.log(e);
    return;
  }
};

export const fetchGraphData = async (payload, activeSession) => {
  try {
    const tagId = payload.tagData.filter((item) => {
      if (item.name === tagTypes.ENTRY) {
        return item.id;
      }
    });
    const response = await axiosInstance.post(
      fetchCameraReportDataAggregated(),
      {
        accountname: activeSession.accountId,
        referenceidentifier: {
          tagid: tagId[0].id,
        },
        filter: {
          $selection: payload.dateRange
            ? payload.dateRange
            : "(createdon > '2023-12-05T15:58:35.658Z') ",
          $aggs: [
            {
              name: "peopleCount_overtime",
              kind: "sumininterval",
              field: "fields.PeopleCount.count",
              datehistogram: {
                field: "createdon",
                fixedinterval: payload.interval ? payload.interval : "30m",
              },
            },
          ],
        },
      }
    );
    const res = response.data;
    return res;
  } catch (e) {
    console.log(e);
    return;
  }
};

export const fetchExitGraphData = async (payload, activeSession) => {
  try {
    const tagId = payload.tagData.filter((item) => {
      if (item.name === tagTypes.EXIT) {
        return item.id;
      }
    });
    const response = await axiosInstance.post(
      fetchCameraReportDataAggregated(),
      {
        accountname: activeSession.accountId,
        referenceidentifier: {
          tagid: tagId[0].id,
        },
        filter: {
          $selection: payload.dateRange
            ? payload.dateRange
            : "(createdon > '2023-12-05T15:58:35.658Z') ",
          $aggs: [
            {
              name: "peopleCount_overtime",
              kind: "sumininterval",
              field: "fields.PeopleCount.count",
              datehistogram: {
                field: "createdon",
                fixedinterval: payload.interval ? payload.interval : "30m",
              },
            },
          ],
        },
      }
    );
    const res = response.data;
    return res;
  } catch (e) {
    console.log(e);
    return;
  }
};

export const fetchCameraGraphData = async (payload, activeSession) => {
  try {
    const response = await axiosInstance.post(
      fetchCameraReportDataAggregated(),
      {
        accountname: activeSession.accountId,
        resourceidentifier: {
          deviceId: payload.cameraId,
        },
        filter: {
          $selection: payload.dateRange
            ? payload.dateRange
            : "(createdon > '2023-12-15T12:30:35.658Z') ",
          $aggs: [
            {
              name: "peopleCount_overtime",
              kind: "sumininterval",
              field: "fields.PeopleCount.count",
              datehistogram: {
                field: "createdon",
                fixedinterval: payload.interval ? payload.interval : "30m",
              },
            },
            {
              name: "waitTime_overtime",
              kind: "sumininterval",
              field: "fields.AverageWaitTime.average",
              datehistogram: {
                field: "createdon",
                fixedinterval: payload.interval ? payload.interval : "30m",
              },
            },
          ],
        },
      }
    );
    const res = response.data;
    return res;
  } catch (e) {
    console.log(e);
    return;
  }
};

export const getConcessionsAverageWaitTime = async (reportData, tagData) => {
  return await getAverageWaitTimeOf(tagTypes.CONCESSION, reportData, tagData);
};

export const getBathroomsAverageWaitTime = async (reportData, tagData) => {
  return await getAverageWaitTimeOf(tagTypes.BATHROOM, reportData, tagData);
};

export const getConcessionsPeopleCount = async (reportData, tagData) => {
  return await getTotalCountOf(tagTypes.CONCESSION, reportData, tagData);
};

export const getBathroomsPeopleCount = async (reportData, tagData) => {
  return await getTotalCountOf(tagTypes.BATHROOM, reportData, tagData);
};

export const getEntryCount = async (reportData, tagData) => {
  return await getTotalCountOf(tagTypes.ENTRY, reportData, tagData);
};

export const getExitCount = async (reportData, tagData) => {
  return await getTotalCountOf(tagTypes.EXIT, reportData, tagData);
};

export const reportFetchAction = async (
  reportData,
  tagData = storedTagIds()
) => {
  tagData = tagData.length > 0 ? tagData : storedTagIds();
  let concessionPC = await getConcessionsPeopleCount(reportData, tagData);
  let bathroomPC = await getBathroomsPeopleCount(reportData, tagData);
  let concessionWT = await getConcessionsAverageWaitTime(reportData, tagData);
  let bathroomWT = await getBathroomsAverageWaitTime(reportData, tagData);
  let entryC = await getEntryCount(reportData, tagData);
  let exitC = await getExitCount(reportData, tagData);
  let data = {
    allReportData: reportData,
    concessionsPeopleCount: concessionPC,
    bathroomsPeopleCount: bathroomPC,
    linePeopleCount: concessionPC + bathroomPC,
    concessionWaitTime: concessionWT,
    bathroomsWaitTime: bathroomWT,
    waitTime: (concessionWT + bathroomWT) / 2,
    entryCount: entryC == NaN ? 0 : entryC,
    exitCount: exitC == NaN ? 0 : exitC,
    peopleCount: entryC == NaN ? 0 : entryC - (exitC == NaN) ? 0 : exitC,
  };
  return data;
};

export const getTotalPeopleCount = (reportData) => {
  try {
    let totalSum = 0;
    reportData.forEach((dataObject) => {
      const keys = Object.keys(dataObject);
      if (keys.length > 0) {
        const latestCountPeople = getLatestCountPeople(dataObject[keys[0]]);
        totalSum += latestCountPeople;
      }
    });
    return totalSum;
  } catch (e) {
    console.log(e);
    return 0;
  }
};

export const getAverageWaitTime = (reportData) => {
  try {
    let totalSum = 0;
    let totalCount = 0;
    reportData.forEach((dataObject) => {
      const keys = Object.keys(dataObject);
      if (keys.length > 0) {
        const latestWaitTime = getLatestWaitTime(dataObject[keys[0]]);
        totalSum += latestWaitTime;
        totalCount++;
      }
    });
    return totalCount > 0 ? totalSum / totalCount : 0;
  } catch (e) {
    console.log(e);
    return 0;
  }
};

function getLatestCountPeople(array) {
  if (array.length > 0) {
    const filteredArray = array?.filter((item) => {
      return item.fields.PeopleCount?.count !== undefined;
    });
    const sortedArray = filteredArray.sort(
      (a, b) => new Date(b.createdon) - new Date(a.createdon)
    );
    return sortedArray.length > 0
      ? Number(sortedArray[0].fields.PeopleCount?.count, 10)
      : 0;
  } else {
    return 0;
  }
}

function getLatestWaitTime(array) {
  if (array.length > 0) {
    const filteredArray = array.filter((item) => {
      return item.fields.AverageWaitTime?.average !== undefined;
    });
    const sortedArray = filteredArray.sort(
      (a, b) => new Date(b.createdon) - new Date(a.createdon)
    );
    return sortedArray.length > 0
      ? Number(sortedArray[0].fields.AverageWaitTime?.average, 10)
      : 0;
  } else {
    return 0;
  }
}

async function getAverageWaitTimeOf(
  tagType,
  reportData,
  tagData = storedTagIds()
) {
  try {
    tagData = tagData.length > 0 ? tagData : storedTagIds();
    const tagId = tagData.filter((item) => {
      if (item.name === tagType) {
        return item.id;
      }
    });
    const cameralist = JSON.parse(sessionStorage.getItem(`deviceList`)).filter(
      (item) => item.kind === "ts.device.onvif.fov"
    );
    const concessionCameraList = cameralist.filter((camData) => {
      if (camData.tagids) {
        if (camData.tagids.some((item) => item.id === tagId[0].id)) {
          return camData.refid;
        }
      }
    });
    const cameraIds = concessionCameraList.map((obj) => obj.refid);
    const filteredArray = reportData.filter((item) => {
      return cameraIds.includes(Object.keys(item)[0]);
    });
    return getAverageWaitTime(filteredArray);
  } catch (e) {
    console.log(e);
    return 0;
  }
}

async function getTotalCountOf(tagType, reportData, tagData = storedTagIds()) {
  try {
    tagData = tagData.length > 0 ? tagData : storedTagIds();
    const tagId = tagData.filter((item) => {
      if (item.name === tagType) {
        return item.id;
      }
    });
    const cameralist = JSON.parse(sessionStorage.getItem(`deviceList`)).filter(
      (item) => item.kind === "ts.device.onvif.fov"
    );
    const concessionCameraList = cameralist.filter((camData) => {
      if (camData.tagids) {
        if (camData.tagids.some((item) => item.id === tagId[0].id)) {
          return camData.refid;
        }
      }
    });
    const cameraIds = concessionCameraList.map((obj) => obj.refid);
    const filteredArray = reportData.filter((item) => {
      return cameraIds.includes(Object.keys(item)[0]);
    });
    return getTotalPeopleCount(filteredArray);
  } catch (e) {
    console.log(e);
    return 0;
  }
}

export const calculateAverageWaitTime = (data) => {
  if (data) {
    let total = 0;
    data.forEach((item) => {
      total += item.avgWaitTime;
    });
    return convertNumToTime(total / data.length);
  } else {
    return 0;
  }
};

export const calculateTotalCount = (data) => {
  if (data) {
    let total = 0;
    data.forEach((item) => {
      total += item.totalCount;
    });
    return total;
  } else {
    return 0;
  }
};

export const sortInDecendingOrder = (data) => {
  return data?.length > 0
    ? data.sort((item1, item2) => {
        return item2.currentWaitTime - item1.currentWaitTime;
      })
    : [];
};

export const sortInDecendingOrderOfWaitTime = (data) => {
  return data?.length > 0
    ? data.sort((item1, item2) => {
        return item2.waitTime - item1.waitTime;
      })
    : [];
};

export const sortInAscendingOrder = (data) => {
  return data?.length > 0
    ? data.sort((item1, item2) => {
        return item1.currentWaitTime - item2.currentWaitTime;
      })
    : [];
};

export const sortInDecendingOrderOfCount = (data) => {
  return data?.length > 0
    ? data.sort((item1, item2) => {
        return item2.count - item1.count;
      })
    : [];
};

export const fetchReportData = async (payload, activeSession) => {
  try {
    const reportDetails = [];
    if (payload.tagQuery.length > 0) {
      const tags = [];
      payload.tagQuery.forEach((tagType) => {
        payload.tagData.forEach((item) => {
          if (item.name === tagType) {
            tags.push(item.id);
          }
        });
      });

      const cameralist = JSON.parse(
        sessionStorage.getItem(`deviceList`)
      ).filter((item) => item.kind === "ts.device.onvif.fov");
      const filteredCameraList = cameralist.filter((camData) => {
        if (camData.tagids) {
          if (camData.tagids.some((item) => tags.includes(item))) {
            return camData.refid;
          }
        }
      });
      let reportData = await Promise.all(
        filteredCameraList.map((obj) =>
          fetchReportForCamera(obj, payload.dateRange, activeSession)
        )
      );
      const cameraIds = reportData.map((obj) => Object.keys(obj)[0]);
      const cameraNames = [];
      const cameraLocations = [];
      const tagIds = [];
      const qrCodes = [];
      cameraIds.forEach((cameraId) => {
        cameralist.forEach((camera) => {
          if (camera.refid === cameraId) {
            cameraNames.push(camera.name);
            cameraLocations.push(
              getCameraObjectbyId(camera.parentdeviceid)[0]?.customdata
                ?.location
            );
            tagIds.push(camera.tagids);
            qrCodes.push(camera.refid);
          }
        });
      });
      const dataArray = reportData.map((obj) => Object.values(obj)[0]);
      dataArray.forEach((dataObject, index) => {
        const detailsObject = {};
        detailsObject.name = cameraNames[index];
        detailsObject.location = cameraLocations[index];
        detailsObject.tagIds = tagIds[index];
        detailsObject.refid = qrCodes[index];
        detailsObject.count = getLatestCountPeople(dataObject);
        detailsObject.currentWaitTime = getLatestWaitTime(dataObject);
        detailsObject.avgWaitTime =
          calculateAverageWaitTimeForReports(dataObject);
        detailsObject.totalCount = calculateTotalCountForReports(dataObject);
        reportDetails.push(detailsObject);
      });
    }
    return reportDetails;
  } catch (e) {
    console.log(e);
    return [];
  }
};

const calculateAverageWaitTimeForReports = (data) => {
  if (data.length > 0) {
    const filteredArray = data.filter((item) => {
      return item.fields.AverageWaitTime?.average !== undefined;
    });
    let total = 0;
    filteredArray.forEach((item) => {
      total += item.fields.AverageWaitTime.average;
    });
    return total / data.length;
  } else {
    return 0;
  }
};

const calculateTotalCountForReports = (data) => {
  if (data.length > 0) {
    const filteredArray = data.filter((item) => {
      return item.fields.PeopleCount?.count !== undefined;
    });
    let total = 0;
    filteredArray.forEach((item) => {
      total += item.fields.PeopleCount.count;
    });
    return total;
  } else {
    return 0;
  }
};

export const filterReports = (data, name) => {
  return data.filter((item) => {
    return item.tagIds.some((d) => getTagName(d) === name);
  });
};

export const filterBathroomsReports = (data) => {
  return data.filter((item) => {
    return item.tagIds.some((d) => d.name === tagTypes.BATHROOM);
  });
};

export const getCameraLocationForGivenID = (cameraId) => {
  const cameralist = JSON.parse(sessionStorage.getItem(`deviceList`)).filter(
    (item) => item.kind === "ts.device.onvif.fov"
  );
  const arr = cameralist?.filter((item) => {
    return item.refid === cameraId;
  });
  return arr?.length > 0 ? arr[0].customdata.location : "Not Available";
};

export const getCameraObjectbyId = (cameraId) => {
  const cameralist = JSON.parse(
    sessionStorage.getItem(`${DEVICE_STORAGE_NAMES[4]}`)
  );
  const filteredCameras = cameralist?.filter((item) => item.refid === cameraId);
  return filteredCameras;
};

export const getCamerabyId = (cameraId) => {
  const cameralist = JSON.parse(
    sessionStorage.getItem(`${DEVICE_STORAGE_NAMES[4]}`)
  );
  const filteredCameras = cameralist?.filter((item) => item.id === cameraId || item.qrcode === cameraId);
  return filteredCameras;
};

export const topAreasBy = (type, areas) => {
  let topAreas = [];
  if (type === reportType.WAIT_TIME) {
    topAreas = sortInDecendingOrderOfWaitTime(areas);
  } else {
    topAreas = sortInDecendingOrderOfCount(areas);
  }
  return topAreas.slice(0, 3);
};

export const getAreasAggregate = (areas) => {
  let data = {};
  let totalCount = 0;
  let totalWaitTime = 0;
  let totalNumber = 0;
  areas.forEach((item) => {
    totalNumber += 1;
    totalCount += item.count;
    totalWaitTime += item.waitTime;
  });
  data.count = totalCount === 0 ? 0 : totalCount;
  data.waitTime = totalWaitTime === 0 ? 0 : totalWaitTime / totalNumber;
  return data;
};

export const getTagNames = (areas) => {
  let data = [];
  areas.forEach((item) => {
    data.push(item.areaName);
  });
  return data;
};

export const getTagNamesFromTagData = (areas) => {
  let data = [];
  areas?.forEach((item) => {
    data.push(item.name);
  });
  return data;
};

export const getTagName = (id, tagData) => {
  //const tagData = JSON.parse(sessionStorage.getItem("TagIdsList"));
  const tagId = tagData?.filter((item) => {
    if (item.id === id) {
      return item.name;
    }
  });
  return tagId[0]?.name;
};

export const updateIsLinkStatus = (siteList) => {
  const updateList = (list) => {
    if (!Array.isArray(list)) {
      console.error("Expected an array but got:", list);
      return [];
    }
    return list.map((site) => {
      const isLink = !site.isCampus;
      const updatedSite = { ...site, isLink };

      if (site.children && site.children.length > 0) {
        updatedSite.children = updateList(site.children);
      }

      return updatedSite;
    });
  };
  return updateList(siteList);
};
